import React from "react";

import styles from "./radiobutton.module.scss";

/** It's a radio button so we don't need to define it */
type InputAttributes = Omit<
    React.AllHTMLAttributes<HTMLInputElement>,
    "type"
> & {
    children: React.ReactNode;
};

export const RadioButton = ({ children, ...props }: InputAttributes) => (
    <label className={styles.radio} htmlFor={props.id}>
        <input {...props} type="radio" />
        {children}
    </label>
);
